import React, { useState, useEffect, useContext } from "react";
import axios from "../../../axios/index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { UserContext } from "../../Context/UserContextProvider";

// components
import ImageUploading from "react-images-uploading";
import { Form } from "react-bootstrap";
import { userAccountValidate } from "./userAccountValidate";

// Styles
import styles from "../../Dashboard/Profile/MyAccount.module.css";

// Image
import cameraUploadIcon from "./../../../assets/img/DashboardICons/cameraUploadBlue.svg";

export default function UserProfileInfo(props) {
  const { userToken } = useContext(UserContext);
  const [userProfileValue, setUserProfileValue] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [formValue, setFormValue] = useState({
    firstName: "",
    lastName: "",
    cardId: "",
    phone: "",
    email: "",
    birthDate: "",
    profileUpdated: false,
  });

  const changeProfileHandler = userImage => {
    setUserProfileValue(userImage);
    setFormValue(prev => {
      return { ...prev, profileUpdated: true };
    });
  };

  const formChangeHandler = e => {
    if (e.target.name === "phone") {
      if (e.target.value === "" || e.target.value.match(/^[0-9]+$/)) {
        if (e.target.value.length <= 11) {
          setFormValue(prev => {
            return { ...prev, [e.target.name]: e.target.value };
          });
        }
      }
    } else if (e.target.name === "cardId") {
      if (e.target.value.length <= 10) {
        setFormValue(prev => {
          return { ...prev, [e.target.name]: e.target.value };
        });
      }
    } else {
      setFormValue(prev => {
        return { ...prev, [e.target.name]: e.target.value };
      });
    }
  };

  useEffect(() => {
    setFormValue({
      ...formValue,
      firstName: props.userData?.name,
      lastName: props.userData?.family,
      phone: props.userData?.phoneNumber,
      email: props.userData?.email,
      cardId: props.userData?.id,
      birthDate: props.userData?.birthDate,
    });
  }, [props.userData]);

  useEffect(() => {
    const setValidate = async () => {
      await setErrors(userAccountValidate(formValue, userProfileValue));
    };
    setValidate();
  }, [formValue, userProfileValue]);

  return (
    <>
      <style>
        {`
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }

                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    `}
      </style>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <div dir="rtl" className={`text-right mx-4 px-2 mt-4 mb-3 d-inline-block`}>
        <div className="position-relative d-inline-block my-1" style={{ width: "max-content" }}>
          <ImageUploading value={userProfileValue} onChange={changeProfileHandler} dataURLKey="data_url">
            {({ imageList, onImageUpload }) => (
              <>
                {imageList.length > 0 ? (
                  imageList.map((item, index) => <img key={index} className={`${styles.user_profile_image}`} src={item["data_url"]} alt="user-profile" />)
                ) : (
                  <img
                    loading="lazy"
                    className={`${styles.user_profile_image}`}
                    src={`https://backdev.azrmelk.com/images/users/avatar/${props.avatarName}`}
                    alt="user-profile"
                  />
                )}

                <div
                  className={`${styles.camera_upload_icon_box} d-flex align-items-center justify-content-center position-absolute start-0`}
                  role="button"
                  onClick={onImageUpload}>
                  <img src={cameraUploadIcon} alt="camera-upload-icon" />
                </div>
              </>
            )}
          </ImageUploading>
        </div>

        <div className={`d-flex justify-content-between align-items-start flex-wrap my-4 py-3`}>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="firstName">
              نام
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="firstName"
              name="firstName"
              value={formValue.firstName}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="lastName">
              نام خانوادگی
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="lastName"
              name="lastName"
              value={formValue.lastName}
              onChange={formChangeHandler}
            />
          </Form.Group>
          {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="birthDate">تاریخ تولد</Form.Label>
                        <DatePicker id="birthDate" name="birthDate" value={formValue.birthDate} onChange={birthDateChangeHandler} calendar={persian} locale={persian_fa} format="YYYY-MM-DD" multiple={false} animations={[opacity()]} calendarPosition="bottom-center" />
                    </Form.Group> */}
          {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="cardId">کد ملی </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="number" id="cardId" name="cardId" value={formValue.cardId} onChange={formChangeHandler} />
                    </Form.Group> */}
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="phone">
              شماره تلفن
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="number"
              id="phone"
              name="phone"
              value={formValue.phone}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="email">
              ایمیل
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="email"
              id="email"
              name="email"
              value={formValue.email}
              onChange={formChangeHandler}
            />
          </Form.Group>
        </div>

        <div className="w-100 d-flex align-items-center justify-content-end">
          {btnLoader ? (
            <div className={styles.btn_loader_container}>
              <div className={styles.btn_spinner}></div>
            </div>
          ) : (
            <button className={`${styles.form_submit_btn} text-white border-0`} onClick={submitHandler}>
              ذخیره
            </button>
          )}
        </div>
      </div>
    </>
  );

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال اعمال تغییرات جدید", "success");
    } else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      formSendHandler();
      // console.log(errors)
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // console.log(errors)
      setBtnLoader(false);
    }
  }

  async function formSendHandler() {
    try {
      setBtnLoader(true);
      var data = new FormData();
      data.append("Avatar", formValue.profileUpdated ? userProfileValue[0].file : props.avatarName);
      data.append("Name", formValue.firstName);
      data.append("Family", formValue.lastName);
      data.append("PhoneNumber", formValue.phone);
      data.append("Email", formValue.email);
      data.append("Gender", "1");

      const apiData = await axios.put("Users/Current", data, {
        headers: { authorization: "Bearer " + userToken },
      });

      let oldUserData = JSON.parse(localStorage.getItem("userData"));

      oldUserData["name"] = formValue.firstName;
      oldUserData["lastName"] = formValue.lastName;
      oldUserData["email"] = formValue.email;
      oldUserData["phoneNumber"] = formValue.phone;

      localStorage.setItem("userData", JSON.stringify(oldUserData));

      // console.log(apiData)
      setBtnLoader(false);
      window.location.reload(false);
    } catch (error) {
      // console.log(error)
      notify("خطایی رخ داد", "error");
    }
  }
}
